module.exports = __webpack_public_path__ + "f3792773eb10dfa12695201a58e3b664.MP3";